import PropTypes from "prop-types";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";
import SvgIcon from "../../../../parts/SvgIcon";

const NewMealPlanTemplate = ({ locals: _locals }) => {
  const handleOpenMealPlanModal = (e, planMode) => {
    e.preventDefault();
    submit("/actions/refresh/", {
      method: "GET",
      body: {
        "modal[type]": "handle-meal-plan",
        planMode,
      },
    });
  };

  return (
    <Modal className="create-meal-plan-modal" title="Create Meal Plan Template">
      <div className="body">
        <NewMealPlanTemplateOption
          title="Simplified Meal Plan"
          description="Quickly create meal options clients can pick anytime."
          image="file-lines-regular-full"
          planMode="simplified"
          onSelect={handleOpenMealPlanModal}
        />
        <NewMealPlanTemplateOption
          title="Detailed Meal Plan"
          description="Plan your entire week with full control and flexibility."
          image="file-regular-full"
          planMode="detailed"
          onSelect={handleOpenMealPlanModal}
        />
      </div>
    </Modal>
  );
};

const NewMealPlanTemplateOption = ({
  title,
  description,
  image,
  planMode,
  onSelect,
}) => {
  return (
    <button type="button" className="card" onClick={(e) => onSelect(e, planMode)}>
      <div className="card-information">
        <div className="card-icon">
          <SvgIcon src={`/img/new-icons/${image}.svg`} alt="icon" />
        </div>
        <div className="text">
          <p className="p1 mb-0.5">{title}</p>
          <p className="s3">{description}</p>
        </div>
      </div>
      <SvgIcon src="/img/new-icons/arrow-right.svg" alt="icon" />
    </button>
  );
};

NewMealPlanTemplateOption.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  planMode: PropTypes.oneOf(["simplified", "detailed"]).isRequired,
  onSelect: PropTypes.func.isRequired,
};

NewMealPlanTemplate.propTypes = {
  locals: PropTypes.object,
};

export default NewMealPlanTemplate;
